import {useState} from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from './SafeIcon';

const {FiHeart,FiPlus} = FiIcons;

function ProductCard({product,onAdd}) {
  const [saved,setSaved] = useState(false);

  return (
    <motion.article layout initial={{opacity: 0,y: 16}} animate={{opacity: 1,y: 0}} transition={{duration: 0.4}} className="group">
      <div className="relative aspect-[3/4] overflow-hidden bg-[#EDE4D3]">
        <img src={product.image} alt={product.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
        {product.badge && <span className="absolute top-3 left-3 bg-[#1F3D2E] text-[#F7F2EA] font-sans text-[9px] tracking-[0.2em] uppercase px-3 py-1.5">{product.badge}</span>}
        <button onClick={() => setSaved(!saved)} aria-label="Save" className={`absolute top-3 right-3 grid place-items-center w-9 h-9 rounded-full bg-[#F7F2EA]/90 backdrop-blur transition ${saved ? 'text-[#1F3D2E]' : 'text-[#1F1B17]'}`}>
          <SafeIcon icon={FiHeart} className={saved ? 'fill-current' : ''} />
        </button>
        <button onClick={() => onAdd(product)} className="absolute bottom-0 left-0 right-0 bg-[#1F1B17] text-[#F7F2EA] font-sans text-[10px] tracking-[0.2em] uppercase py-3.5 flex items-center justify-center gap-2 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
          Add to bag <SafeIcon icon={FiPlus} />
        </button>
      </div>
      <div className="pt-4 flex justify-between items-start">
        <div>
          <h3 className="font-display text-lg text-[#1F1B17]">{product.name}</h3>
          <p className="mt-1 flex items-center gap-2 font-sans text-[11px] text-[#7A6E62]">
            <span className="w-2.5 h-2.5 rounded-full border border-[#1F1B17]/15" style={{background: product.color}} />{product.tone}
          </p>
        </div>
        <span className="font-sans text-sm text-[#1F3D2E] font-medium">₹{product.price}</span>
      </div>
    </motion.article>
  );
}

export default ProductCard;
